import React, { useState } from 'react';
import styled from 'styled-components';
import colors from '../../components/theme/colors';
import TextInput from '../../components/Donee/components/common/Input/TextInput';
import { Label } from '../../components/Donee/components/common/Text/styles';
import { InputIcon } from '../../components/Donee/components/common/Input/TextInput/styles';
import { ApiHandler } from '../../api';
import { Button } from '../../components';

const FormItem = styled.div`
    padding-bottom: 10px;
`;

const FormSubmitContainer = styled.div`
    width: 360px;
    max-width: 100%;
    position: relative;
    display: inline-block;
    flex-direction: column;
    align-items: center;
`;

const TextInputContainer = styled.div`
    position: relative;
`;

const StyledForm = styled.form`
    input:disabled {
        background-color: ${colors.grayscaleGray100} !important;
        color: ${colors.lightgrey};
    }
    .button-icon {
        top: 14px;
        right: 12px;
        position: absolute;
    }
`;

interface SetPasswordFormProps {
    email: string | undefined;
    token: string;
}

// const defaultDoneeId = '123';
const successMessageText =
    'Successfully set the password. We will redirect you to the main page shortly.';
const SetPasswordForm: React.FC<SetPasswordFormProps> = ({ email, token }) => {
    const [successMessage, setSuccessMessage] = useState<string | undefined>();
    const [loading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] =
        useState<boolean>(false);
    const [error, setError] = useState<string | undefined>();

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const newPassword = (e.target as any)[1].value;
        const confirmPassword = (e.target as any)[2].value;
        if (newPassword !== confirmPassword) {
            setError(
                'Please check if both fields have the same password value.',
            );
            return;
        }
        setError(undefined);
        setApiError('');
        setIsLoading(true);
        const setPasswordReqeust =
            await ApiHandler.instance.auth.userSetPassword(
                newPassword,
                token,
                email,
            );
        if (setPasswordReqeust.success) {
            setSuccessMessage(successMessageText);
            window.setTimeout(() => {
                window.location.href = 'https://www.givelify.com/';
            }, 3000);
        } else {
            setApiError(setPasswordReqeust.error.message);
        }
        setIsLoading(false);
    };

    return (
        <StyledForm onSubmit={onSubmit}>
            {email && (
                <FormItem>
                    <Label
                        variant={'small'}
                        color={'primarySecondaryContent'}
                        marginBottom={8}
                    >
                        Email
                    </Label>
                    <TextInputContainer>
                        <TextInput
                            disabled
                            required
                            type={'email'}
                            id={'email'}
                            name={'email'}
                            value={email}
                            maxLength={255}
                        />
                    </TextInputContainer>
                </FormItem>
            )}
            <FormItem>
                <Label
                    variant={'small'}
                    color={'primarySecondaryContent'}
                    marginBottom={8}
                >
                    New Password
                </Label>
                <TextInputContainer>
                    <TextInput
                        required
                        id={'new-password'}
                        name={'new-password'}
                        type={!showNewPassword ? 'password' : 'text'}
                        maxLength={255}
                    />
                    <InputIcon
                        onClick={() => setShowNewPassword((s) => !s)}
                        size={'xSmall'}
                        className="button-icon"
                        name={!showNewPassword ? 'pass_hide' : 'pass_show'}
                    />
                </TextInputContainer>
            </FormItem>
            <FormItem>
                <Label
                    variant={'small'}
                    color={'primarySecondaryContent'}
                    marginBottom={8}
                >
                    Confirm Password
                </Label>
                <TextInputContainer>
                    <TextInput
                        required
                        id={'confirm-password'}
                        name={'confirm-password'}
                        type={!showConfirmPassword ? 'password' : 'text'}
                        maxLength={255}
                    />
                    <InputIcon
                        onClick={() => setShowConfirmPassword((s) => !s)}
                        size={'xSmall'}
                        className="button-icon"
                        name={!showConfirmPassword ? 'pass_hide' : 'pass_show'}
                    />
                </TextInputContainer>
            </FormItem>
            {(error || apiError) && (
                <Label
                    variant={'xSmall'}
                    color={'red'}
                    weight={undefined}
                >
                    {error || apiError || 'Unable to set password.'}
                </Label>
            )}
            {successMessage && (
                <Label
                    color={'utilitySuccess'}
                    weight={undefined}
                >
                    {successMessage}
                </Label>
            )}
            <div className={'mt-30 text-center'}>
                <FormSubmitContainer>
                    <Button
                        className="w-full"
                        disabled={loading || Boolean(successMessage)}
                        type="submit"
                    >
                        {loading ? 'Setting Password' : 'Set Password'}
                    </Button>
                </FormSubmitContainer>
            </div>
        </StyledForm>
    );
};

export default SetPasswordForm;
